import React from "react";
import { FiFacebook, FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import {
  Brand,
  BottomBar,
  Column,
  ColumnTitle,
  ContactItem,
  ContactLink,
  FooterContainer,
  FooterInner,
  FooterLink,
  FooterLinks,
  FooterLogo,
  Motto,
  SocialLink,
} from "./FooterElements";
import { useLanguage } from "../../../contexts/LanguageContext";
import { EMAIL, FACEBOOK_URL, PHONE_NUMBERS, toTelHref } from "../../../utils";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <FooterContainer>
      <FooterInner>
        <Brand>
          <FooterLogo
            alt={t("HOME.HEADER.TITLE")}
            src={require("../../../assets/images/logos/100x200-white.png")}
          />
          <Motto>{t("HOME.HEADER.SUBTITLE")}</Motto>
          <SocialLink
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FiFacebook />
          </SocialLink>
        </Brand>

        <Column>
          <ColumnTitle>{t("NAVIGATION.MENU")}</ColumnTitle>
          <FooterLinks>
            <FooterLink to="/" end>
              {t("NAVIGATION.HOME")}
            </FooterLink>
            <FooterLink to="/products">{t("NAVIGATION.PRODUCTS")}</FooterLink>
            <FooterLink to="/about">{t("NAVIGATION.ABOUT")}</FooterLink>
            <FooterLink to="/contact">{t("NAVIGATION.CONTACT")}</FooterLink>
          </FooterLinks>
        </Column>

        <Column>
          <ColumnTitle>{t("NAVIGATION.CONTACT")}</ColumnTitle>
          <ContactLink href={toTelHref(PHONE_NUMBERS[0])}>
            <FiPhone />
            {PHONE_NUMBERS[0]}
          </ContactLink>
          <ContactLink href={`mailto:${EMAIL}`}>
            <FiMail />
            {EMAIL}
          </ContactLink>
          <ContactItem>
            <FiMapPin />
            <span>
              {t("FOOTER.ADDRESS1")}
              <br />
              {t("FOOTER.ADDRESS2")}
            </span>
          </ContactItem>
        </Column>
      </FooterInner>

      <BottomBar>
        © {new Date().getFullYear()} {t("HOME.HEADER.TITLE")}.{" "}
        {t("FOOTER.RIGHTS")}
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer;
